import "@flexfreight/ui/tokens.css";
import "@flexfreight/ui/base.css";
import "@flexfreight/ui/components.css";
import "@flexfreight/ui/controls.css";
import "@flexfreight/ui/ds.css";
import "@flexfreight/ui/toast.css";
import "@flexfreight/ui/shell.css";
import "./console.css";
import { FfToaster } from "@flexfreight/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./routes";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } } });

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={createBrowserRouter(routes)} />
      <FfToaster theme={document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark"} />
    </QueryClientProvider>
  </StrictMode>,
);
